import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2, Ship, Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function AdminLogin() {
  const { user, ready, signIn } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (ready && user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signIn(email, password);
      toast.success("Welcome back!");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail, "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#06281A] px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-white/5 p-8 backdrop-blur-xl">
        <div className="flex items-center gap-2.5">
          <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary text-white"><Ship className="h-5 w-5" /></span>
          <div>
            <p className="font-heading font-bold text-white">Domaleo Admin</p>
            <p className="text-xs text-slate-400">Content Management</p>
          </div>
        </div>
        <h1 className="mt-8 font-heading text-2xl font-semibold text-white">Sign in</h1>
        <p className="mt-1 text-sm text-slate-400">Manage your website content and inquiries.</p>
        <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-sm text-slate-300">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email-input"
              className="mt-1.5 w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-accent" placeholder="admin@domaleogh.com" />
          </div>
          <div>
            <label className="text-sm text-slate-300">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password-input"
              className="mt-1.5 w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-accent" placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-accent px-6 py-3 text-sm font-semibold text-[#06281A] transition-transform hover:scale-[1.02] disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
